import React from "react";
import { useLocation } from "react-router-dom";
import BasicHeader from "@components/BasicLayout/BasicHeader";
import BasicRouter from "@/router";
import { checkTestHost, getSearchParam } from "@/utils";
import PrivacyAgree from "./PrivacyAgree";
import sendErrMsg from "@/utils/sendErrMsg";
import { isShowNews1 } from "@/utils/isShowNews1";
import { useAdCpt } from "@/hooks/App/useAdCpt.tsx";
import { useGoogleAd1 } from "@/hooks/useGoogleAd";
import { useCptUtil } from "./useCptUtil.tsx";
import TestTips2 from "../TestTips2/index.tsx";
import { miQsWeatherDomains } from "@/constants/domain.config";
import MqsInterstitialController from "./MqsInterstitialController";
const EXCLUDED_PATHS = ["/news", "/news/detail", "/daily/detail"];

export const onResizeObserver = (callback: (entries: ResizeObserverEntry[]) => void) => {
  return new ResizeObserver(entries => callback?.(entries));
};

const getAdIndex = (pathname: string): number | string => {
  switch (pathname) {
    case "/hourly":
      return 1;
    case "/daily":
      return 3;
    case "/sun-moon":
      return 8;
    default:
      return "";
  }
};

const BasicLayout: React.FC = () => {
  const { pathname } = useLocation();
  const { hostName } = useHostName();
  const AdComponent = useAdCpt();
  const mqsInterstitialConfig = useGoogleAd1("adInterstitial", 0);
  const isMqsHost = miQsWeatherDomains.includes(hostName);
  const isMqsInterstitialEnabled = isMqsHost && !!mqsInterstitialConfig;
  const [interstitialRequestKey, setInterstitialRequestKey] = useState(0);
  const test_geo = getSearchParam("test_geo") || "";
  try {
    const adIndex = getAdIndex(pathname);
    const isWiDomain = domainMap["wi"].includes(hostName);
    const shouldShowUpdating = !EXCLUDED_PATHS.some(path => pathname.startsWith(path));
    const { getCpt01, getCpt02 } = useCptUtil({
      shouldShowUpdating,
      isShowNews1ValidMain: isShowNews1().validMain,
      checkTestHostResult: checkTestHost(domainLinks),
      pathname,
      homeRoutePath: "/home",
      isWiDomain,
      hostName,
      adIndex,
    });
    const requestInterstitialOnNavigation = useCallback(() => {
      if (!isMqsInterstitialEnabled) {
        return;
      }

      setInterstitialRequestKey(prev => prev + 1);
    }, [isMqsInterstitialEnabled]);

    return (
      <>
        {test_geo === "1" && <TestTips2 />}
        <BasicHeader onRequestMqsInterstitial={requestInterstitialOnNavigation} />
        {isMqsInterstitialEnabled ? (
          <MqsInterstitialController
            config={mqsInterstitialConfig}
            enabled={isMqsInterstitialEnabled}
            requestKey={interstitialRequestKey}
          />
        ) : null}
        {getCpt01()}
        <div className="app-container" {...(isMqsHost ? { "data-google-interstitial": "false" } : {})}>
          {/* 方式1 */}
          <BasicRouter />
          {/* 方式2 */}
          {/* {element} */}
          <div data-position="position-03">
            {getCpt02({
              dataPosition: "position-03",
              adSize: "ad1",
            })}
          </div>
          <PrivacyAgree />
        </div>
        {AdComponent}
      </>
    );
  } catch (error: unknown) {
    sendErrMsg();
  }
};

export default BasicLayout;
